<template>
  <BaseDataList
    ref="dataList"
    :items="contacts"
    :service="fetchPossibleDuplicateContacts"
    allow-search
    nested
  >
    <template #header>
      <ContactListHeader
        :primary-criteria="primaryCriteria"
        @change-primary-criteria="changePrimaryCriteria"
      />
    </template>

    <template #default="{ item }">
      <ContactListItem :contact="item" />
    </template>
  </BaseDataList>
</template>

<script>
import ContactListHeader from './contact-list-header.vue';
import ContactListItem from './contact-list-item.vue';

export default {
  components: {
    ContactListHeader,
    ContactListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      primaryCriteria: 'email_address',
    };
  },
  computed: {
    account() {
      return this.$store.state.entities.accounts.byId[this.accountId];
    },
    contacts() {
      return this.$store.getters[`${this.accountId}:contactMerge/contacts`];
    },
  },
  destroyed() {
    this.$store.dispatch('ui/accountContacts/clearByParent', { parentId: this.accountId });
  },
  methods: {
    resetList() {
      this.$refs.dataList.resetList();
    },
    changePrimaryCriteria(primaryCriteria) {
      this.primaryCriteria = primaryCriteria;
      this.$refs.dataList.resetList();
    },
    async fetchPossibleDuplicateContacts(params = {}) {
      try {
        const response = await this.$store.dispatch(
          `${this.accountId}:contactMerge/fetchPossibleDuplicateRecords`,
          {
            ...params,
            include: 'primaryEmailAddress,primaryPhoneNumber,emailAddresses,phoneNumbers',
            primary_criteria: this.primaryCriteria,
            page_size: 5,
          }
        );

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
